// extracted by mini-css-extract-plugin
export default {"link":"src-modules-registration-subaccount-registration-style__link_ZSf+g"};